/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Empty_ItemsInputs */

const vi_pdc_empty_items = /** @type {(inputs: Pdc_Empty_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có dòng nào`)
};

/**

* @param {Pdc_Empty_ItemsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_empty_items = /** @type {((inputs?: Pdc_Empty_ItemsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Empty_ItemsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_empty_items(inputs)
});